export default "__VITE_PUBLIC_ASSET__f37c2e64__"